import { useQuery } from 'react-query';

import { inviteCodesApi } from 'src/Services/API';

const useValidateInviteCode = (code: string) => {
  return useQuery({
    queryKey: ['validate-invite-code', code],
    queryFn: async () => {
      const response = await inviteCodesApi.inviteCodesControllerValidate(code);
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    enabled: !!code,
    retry: false,
  });
};

export default useValidateInviteCode;
